import React from 'react';

export default function NavigationTabs({ activeTab, onTabChange }) {
  const getTabStyle = (tab) => ({
    padding: '10px 20px',
    border: 'none',
    borderBottom: activeTab === tab ? '3px solid #0056b3' : '3px solid transparent',
    background: activeTab === tab ? '#f8f9fa' : 'transparent',
    color: activeTab === tab ? '#0056b3' : '#6c757d',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '1rem',
    borderRadius: '4px 4px 0 0'
  });

  return (
    <div style={{ display: 'flex', gap: '8px', marginBottom: '1.5rem', borderBottom: '1px solid #dee2e6' }}>
      <button type="button" onClick={() => onTabChange('single')} style={getTabStyle('single')}>
        📄 Single Certificate Lifecycle
      </button>
      <button type="button" onClick={() => onTabChange('bulk')} style={getTabStyle('bulk')}>
        📦 Asynchronous Bulk Ingestion (Redis / BullMQ)
      </button>
    </div>
  );
}